import { formatDistanceToNowStrict } from 'date-fns';

import { useChatActions } from '@/features/ai-chat/state/useChat';
import type { Conversation } from '@/features/ai-chat/types/chat.types';

export function useHistoryRecord(conversation: Conversation, handleClose: () => void) {
  const { restoreConversation } = useChatActions();

  const timeAgo = formatDistanceToNowStrict(new Date(conversation.timestamp));

  const handleClick = () => {
    restoreConversation(conversation);
    handleClose();
  };

  return { timeAgo, handleClick } as const;
}
